module.exports = __webpack_public_path__ + "static/media/03. Matalokal.47f15231.png";